
import React from 'react';
import { motion } from 'framer-motion';
import { protocolData } from '../data';
import { FiAlertTriangle, FiShield } from 'react-icons/fi';
import './ContingencyPlan.css';

const ContingencyPlan = () => {
    const { contingencyPlan } = protocolData;

    return (
        <motion.section
            id="contingency-plan"
            className="section"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.5 }}
        >
            <h2 className="section-title">{contingencyPlan.title}</h2>
            
            {contingencyPlan.scenarios.map((scenario, index) => (
                <motion.div 
                    key={index} 
                    className="contingency-card"
                    initial={{ opacity: 0, scale: 0.95 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    viewport={{ once: true, amount: 0.5 }}
                    transition={{ duration: 0.4, delay: index * 0.1 }}
                >
                    <div className="card-header">
                        <FiAlertTriangle className="card-icon" />
                        <h3>{scenario.condition}</h3>
                    </div>
                    <div className="card-body">
                        {scenario.actions.map((action, actionIndex) => (
                            <div key={actionIndex} className="action-step">
                                <h4>{action.step}</h4>
                                <p>{action.description}</p>
                            </div>
                        ))}
                    </div>
                </motion.div>
            ))}

             <motion.div 
                className="contingency-card high-alert"
                initial={{ opacity: 0, scale: 0.95 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true, amount: 0.5 }}
                transition={{ duration: 0.4, delay: 0.2 }}
            >
                <div className="card-header">
                    <FiShield className="card-icon high-alert-icon" />
                    <h3>{contingencyPlan.directIntervention.title}</h3>
                </div>
                <div className="card-body">
                   <p>{contingencyPlan.directIntervention.description}</p>
                </div>
            </motion.div>


            <p className="living-document-note">{contingencyPlan.note}</p>
            <p className="core-principles">
                <strong>Core Principles:</strong>
                {contingencyPlan.corePrinciples.join(' | ')}
            </p>

        </motion.section>
    );
};

export default ContingencyPlan;
